import OlbLoginItem from '@/shared/components/loginItem.vue';
import OlbTotop from '@/shared/components/totop.vue';
import OlbLogin from '@/shared/components/login.vue';
import OlbClock from '@/shared/components/clock.vue';
import OlbSearch from '@/shared/components/search.vue';
import OlbSearchSticky from '@/shared/components/searchSticky.vue';
import OlbQuickNav from '@/shared/components/quickNav.vue';
import OlbNavigation from '@/shared/components/navigation.vue';
import OlbSticky from '@/shared/components/sticky.vue';
import OlbLanguage from '@/shared/components/language.vue';
import OlbStock from '@/shared/components/stock.vue';
import OlbEtrackerDirective from '@/shared/directives/etracker';
import OlbPostlinkDirective from '@/shared/directives/postlink';
import OlbTeaserLinkDirective from '@/shared/directives/teaserLink';
import {
	OlbBreadcrumb,
	OlbBreadcrumbItem,
	OlbButton,
	OlbCarousel,
	OlbEyecatcher,
	OlbIcon,
	OlbImage,
	OlbPage,
	OlbLogo,
	OlbStickyDirective,
} from '@olbbank/vue-components';
/**
 * Lazyloaded
 */
const OlbAccordion = () => import('@olbbank/vue-components').then((module) => module.OlbAccordion);
const OlbAmount = () => import('@olbbank/vue-components').then((module) => module.OlbAmount);
const OlbAccordionItem = () => import('@olbbank/vue-components').then((module) => module.OlbAccordionItem);
const OlbBackButton = () => import('@olbbank/vue-components').then((module) => module.OlbBackButton);
const OlbBaufi = () => import('@olbbank/vue-components').then((module) => module.OlbBaufi);
const OlbBlog = () => import('@olbbank/vue-components').then((module) => module.OlbBlog);
const OlbBranchList = () => import('@olbbank/vue-components').then((module) => module.OlbBranchList);
const OlbBranchListItem = () => import('@olbbank/vue-components').then((module) => module.OlbBranchListItem);
const OlbCheckbox = () => import('@olbbank/vue-components').then((module) => module.OlbCheckbox);
const OlbContentSlider = () => import('@olbbank/vue-components').then((module) => module.OlbContentSlider);
const OlbDatepicker = () => import('@olbbank/vue-components').then((module) => module.OlbDatepicker);
const OlbDialog = () => import('@olbbank/vue-components').then((module) => module.OlbDialog);
const OlbFlyoutSelect = () => import('@olbbank/vue-components').then((module) => module.OlbFlyoutSelect);
const OlbFormFilter = () => import('@/shared/components/formFilter.vue');
const OlbFormRentCalculator = () => import('@olbbank/vue-components').then((module) => module.OlbFormRentCalculator);
const OlbFormFinancingCalculator = () =>
	import('@olbbank/vue-components').then((module) => module.OlbFormFinancingCalculator);
const OlbFormContact = () => import('@olbbank/vue-components').then((module) => module.OlbFormContact);
const OlbFormCredentials = () => import('@olbbank/vue-components').then((module) => module.OlbFormCredentials);
const OlbFormOpinion = () => import('@olbbank/vue-components').then((module) => module.OlbFormOpinion);
const OlbFormLandingpage = () => import('@olbbank/vue-components').then((module) => module.OlbFormLandingpage);
const OlbFormNewsletter = () => import('@olbbank/vue-components').then((module) => module.OlbFormNewsletter);
const OlbFormNewsletterWuw = () => import('@olbbank/vue-components').then((module) => module.OlbFormNewsletterWuw);
const OlbFormNewsletterBhn = () => import('@olbbank/vue-components').then((module) => module.OlbFormNewsletterBhn);
const OlbFormWkn = () => import('@olbbank/vue-components').then((module) => module.OlbFormWkn);
const OlbFormWuw = () => import('@olbbank/vue-components').then((module) => module.OlbFormWuw);

const OlbEcon = () => import('@/shared/components/econ.vue');
const OlbExtendedSearch = () => import('@olbbank/vue-components').then((module) => module.OlbExtendedSearch);
const OlbFund = () => import('@olbbank/vue-components').then((module) => module.OlbFund);
const OlbGallery = () => import('@olbbank/vue-components').then((module) => module.OlbGallery);
const OlbImmoSearch = () => import('@olbbank/vue-components').then((module) => module.OlbImmoSearch);
const OlbImmoSearchRef = () => import('@olbbank/vue-components').then((module) => module.OlbImmoSearchRef);
const OlbImmoSearchResults = () => import('@olbbank/vue-components').then((module) => module.OlbImmoSearchResults);
const OlbImmoSearchResultEntry = () =>
	import('@olbbank/vue-components').then((module) => module.OlbImmoSearchResultEntry);
const OlbInput = () => import('@olbbank/vue-components').then((module) => module.OlbInput);
const OlbLoader = () => import('@olbbank/vue-components').then((module) => module.OlbLoader);
const OlbLocationSearch = () => import('@olbbank/vue-components').then((module) => module.OlbLocationSearch);
const OlbMap = () => import('@olbbank/vue-components').then((module) => module.OlbMap);
const OlbMoreLess = () => import('@/shared/components/moreLess.vue');
const OlbNotice = () => import('@olbbank/vue-components').then((module) => module.OlbNotice);
const OlbOption = () => import('@olbbank/vue-components').then((module) => module.OlbOption);
const OlbPager = () => import('@olbbank/vue-components').then((module) => module.OlbPager);
const OlbSchedule = () => import('@olbbank/vue-components').then((module) => module.OlbSchedule);
const OlbSearchFilter = () => import('@olbbank/vue-components').then((module) => module.OlbSearchFilter);
const OlbSearchFilterItem = () => import('@olbbank/vue-components').then((module) => module.OlbSearchFilterItem);
const OlbSearchResults = () => import('@olbbank/vue-components').then((module) => module.OlbSearchResults);
const OlbSelect = () => import('@olbbank/vue-components').then((module) => module.OlbSelect);
const OlbSort = () => import('@olbbank/vue-components').then((module) => module.OlbSort);
const OlbStepper = () => import('@olbbank/vue-components').then((module) => module.OlbStepper);
const OlbTab = () => import('@olbbank/vue-components').then((module) => module.OlbTab);
const OlbTabs = () => import('@olbbank/vue-components').then((module) => module.OlbTabs);
const OlbTableFilter = () => import('@/shared/components/tableFilter.vue');
const OlbTagCloud = () => import('@olbbank/vue-components').then((module) => module.OlbTagCloud);
const OlbTooltip = () => import('@olbbank/vue-components').then((module) => module.OlbTooltip);
const OlbUpload = () => import('@olbbank/vue-components').then((module) => module.OlbUpload);
const OlbVideo = () => import('@olbbank/vue-components').then((module) => module.OlbVideo);
const OlbVideoChat = () => import('@olbbank/vue-components').then((module) => module.OlbVideoChat);
const OlbZoom = () => import('@olbbank/vue-components').then((module) => module.OlbZoom);
const OlbTooltipDirective = () => import('@olbbank/vue-components').then((module) => module.OlbTooltipDirective);

export const components = {
	OlbAccordion,
	OlbAccordionItem,
	OlbAmount,
	OlbBackButton,
	OlbBlog,
	OlbBaufi,
	OlbButton,
	OlbBranchList,
	OlbBranchListItem,
	OlbBreadcrumb,
	OlbBreadcrumbItem,
	OlbCarousel,
	OlbCheckbox,
	OlbContentSlider,
	OlbClock,
	OlbDatepicker,
	OlbDialog,
	OlbEcon,
	OlbExtendedSearch,
	OlbEyecatcher,
	OlbFlyoutSelect,
	OlbFormFilter,
	OlbFormRentCalculator,
	OlbFormFinancingCalculator,
	OlbFormContact,
	OlbFormCredentials,
	OlbFormOpinion,
	OlbFormLandingpage,
	OlbFormNewsletter,
	OlbFormNewsletterWuw,
	OlbFormNewsletterBhn,
	OlbFormWkn,
	OlbFormWuw,
	OlbFund,
	OlbGallery,
	OlbIcon,
	OlbImmoSearch,
	OlbImmoSearchRef,
	OlbImmoSearchResults,
	OlbImmoSearchResultEntry,
	OlbInput,
	OlbImage,
	OlbPage,
	OlbLoader,
	OlbLocationSearch,
	OlbLogin,
	OlbLoginItem,
	OlbLogo,
	OlbMap,
	OlbMoreLess,
	OlbNavigation,
	OlbNotice,
	OlbOption,
	OlbPager,
	OlbQuickNav,
	OlbSchedule,
	OlbSearch,
	OlbSearchSticky,
	OlbSearchFilter,
	OlbSearchFilterItem,
	OlbSearchResults,
	OlbSelect,
	OlbStepper,
	OlbSort,
	OlbSticky,
	OlbStock,
	OlbLanguage,
	OlbTab,
	OlbTabs,
	OlbTableFilter,
	OlbTagCloud,
	OlbTooltip,
	OlbTotop,
	OlbUpload,
	OlbVideo,
	OlbVideoChat,
	OlbZoom,
};
export const directives = {
	OlbEtrackerDirective,
	OlbStickyDirective,
	OlbTooltipDirective,
	OlbPostlinkDirective,
	OlbTeaserLinkDirective,
};
